import { Reducer } from 'redux';
import { DocumentViewerActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  items: [],
};

type IDmvSearchStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IDmvSearchStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DocumentViewerActionTypes.GET_ALL_DOCUMENTS: {
      let _state = { ...state };
      _state = { ..._state, items: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
